module.exports = __webpack_public_path__ + "static/media/rencap-SVG-sprite.c81e0d58.svg";